// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Standalone Voice-Only Service Styles */

/* Ensure full height container */
html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
  /* Block browser pinch / double-tap zoom over the widget. Mirrors the
     touch-action the game canvas (PixiJS) already sets on itself. The widget
     has no scrollable content; if that changes, switch the root to \`pan-y\`
     (an ancestor \`none\` cannot be overridden by a descendant). */
  touch-action: none;
  font-family:
    system-ui,
    -apple-system,
    sans-serif;
}

/* Clean voice-only interface */
.voice-only-app {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #191d26;
}

/* Transparent background for game overlay - the entire iframe is transparent */
html:has(.ai-service-container),
html:has(.ai-service-container) body,
html:has(.ai-service-container) #root {
  background: transparent !important;
}

/* No extra styling needed - LiveKit components handle the UI */
`, "",{"version":3,"sources":["webpack://./src/standalone/standalone-panel.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,iCAAiC;AACjC;;;EAGE,YAAY;EACZ,SAAS;EACT,UAAU;EACV;;;iEAG+D;EAC/D,kBAAkB;EAClB;;;cAGY;AACd;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;;;EAGE,kCAAkC;AACpC;;AAEA,+DAA+D","sourcesContent":["/* Standalone Voice-Only Service Styles */\n\n/* Ensure full height container */\nhtml,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  /* Block browser pinch / double-tap zoom over the widget. Mirrors the\n     touch-action the game canvas (PixiJS) already sets on itself. The widget\n     has no scrollable content; if that changes, switch the root to `pan-y`\n     (an ancestor `none` cannot be overridden by a descendant). */\n  touch-action: none;\n  font-family:\n    system-ui,\n    -apple-system,\n    sans-serif;\n}\n\n/* Clean voice-only interface */\n.voice-only-app {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #191d26;\n}\n\n/* Transparent background for game overlay - the entire iframe is transparent */\nhtml:has(.ai-service-container),\nhtml:has(.ai-service-container) body,\nhtml:has(.ai-service-container) #root {\n  background: transparent !important;\n}\n\n/* No extra styling needed - LiveKit components handle the UI */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
